import { FC } from 'react';

import { CountryViewModel } from '@api/models/CountryViewModel';
import Dropdown from '@components/Dropdown';
import { TURKEY_ID } from '@constants/constants';
import { useCountries } from '@hooks/hooks';
import { DropdownSelectProps } from '@components/Dropdown/DropdownInterface';

export type IDropdownsNationality = DropdownSelectProps<CountryViewModel>;

const Nationality: FC<IDropdownsNationality> = ({
  onChange = () => null,
  ...rest
}) => {
  const countries = useCountries();

  return (
    <Dropdown
      items={countries as CountryViewModel[]}
      renderLabel={(p) => (!p ? 'Uyruk*' : p.name)}
      renderOption={(p) => p.name}
      optionsZIndex={5}
      onChange={(country) =>
        onChange(
          Number(country.code ?? TURKEY_ID) as unknown as CountryViewModel
        )
      }
      {...rest}
    />
  );
};

export default Nationality;
